import qs from "qs";

import {
    useEffectAfterMount,
    useQueryParamsExecute,
    useRouter,
} from "../../../../";
import { MessageSearchActions } from "../_infra/messageListingActions";
import {
    initialMessageListingState,
    MessageListingState,
} from "./messageListingState";

export const useMessageListingHandlers = (
    state: MessageListingState,
    actions: MessageSearchActions
) => {
    const { history, location } = useRouter();

    useQueryParamsExecute(
        actions.search,
        initialMessageListingState.searchCriteria
    );

    useEffectAfterMount(() => {
        const queryString = qs.stringify(state.searchCriteria, {
            skipNulls: true,
            addQueryPrefix: true,
            sort: (a, b) => a.localeCompare(b),
        });
        if (queryString === location.search) return;
        history.push({ search: queryString });
    }, [state.searchCriteria]);
};
